
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
se-container{
  display:flex;
  flex-direction:column;
  overflow:hidden;
}

  @media (min-width: 768px){se-container{
    flex-direction:row
}
  }

.se-featured-content-dep--content-wrapper{
  width:100%;
}

@media (min-width: 768px){

.se-featured-content-dep--content-wrapper{
    max-width:50%
}
  }

.se-featured-content-dep--content{
  display:flex;
  flex-direction:column;
  height:100%;
  justify-content:center;
  padding:3rem 0;
  row-gap:1.25rem;
}

.se-featured-content-dep--content se-heading{
    color:var(--brand-primary-1);
  }

.se-featured-content-dep--content p{
    margin:0;
    font-size:var(--fs-lg-mobile);
    color:var(--brand-neutral-gray-800);
  }

@media (min-width: 768px){

.se-featured-content-dep--content p{
      font-size:var(--fs-lg)
  }
    }

@media (min-width: 1280px){

.se-featured-content-dep--content{
    padding:2rem 6rem 2rem 0
}
  }

@media (min-width: 768px) and (max-width: 1279px){

.se-featured-content-dep--content{
    padding:2rem 2rem 2rem 0;
    row-gap:2rem
}
  }

.se-featured-content-dep--alerts-wrapper{
  width:100%;
  position:relative;
}

.se-featured-content-dep--alerts-wrapper::after{
    content:'';
    display:flex;
    position:absolute;
    height:100%;
    right:-100%;
    left:-100%;
    top:0;
    background:var(--brand-primary-2);
    z-index:0;
  }

@media (min-width: 768px){

.se-featured-content-dep--alerts-wrapper::after{
      right:-100%;
      left:0
  }
    }

@media (min-width: 768px){

.se-featured-content-dep--alerts-wrapper{
    max-width:50%
}
  }

.se-featured-content-dep--alerts{
  display:flex;
  flex-direction:column;
  list-style:none;
  margin:0;
  justify-content:center;
  padding:1rem 0;
}

@media (min-width: 1280px){

.se-featured-content-dep--alerts{
    padding:2rem 0px 2rem 6rem
}
  }

@media (min-width: 768px) and (max-width: 1279px){

.se-featured-content-dep--alerts{
    padding:2rem 0px 2rem 2rem
}
  }

.se-featured-content-dep--alert{
  z-index:1;
  display:flex;
  flex-direction:column;
  padding:2rem 1rem 2rem 0;
  position:relative;
  row-gap:1rem;
  cursor:pointer;
}

.se-featured-content-dep--alert:nth-of-type(n + 2)::after{
      content:'';
      width:100%;
      height:1px;
      background:white;
      position:absolute;
      top:0;
    }

.se-featured-content-dep--alert:hover,
  .se-featured-content-dep--alert:focus{
    outline:2px solid white;
  }

.se-featured-content-dep--alert:hover::after, .se-featured-content-dep--alert:focus::after{
      height:0px;
    }

.se-featured-content-dep--alert-type{
  color:var(--brand-neutral-white);
  letter-spacing:0.5px;
  padding-left:0.5rem;
}

@media (min-width: 768px){

.se-featured-content-dep--alert-type{
    padding:0 1rem
}
  }

.se-featured-content-dep--alert-link{
  color:var(--brand-neutral-white);
  padding:0 0.5rem;
  text-decoration:none;
  font-size:var(--fs-lg-mobile);
  font-weight:var(--fw-medium);
  font-family:var(--ff-dmsans);
}

.se-featured-content-dep--alert-link:hover{
    -webkit-text-decoration-color:var(--brand-neutral-white);
            text-decoration-color:var(--brand-neutral-white);
    text-decoration-thickness:3px;
    text-decoration:underline;
  }

.se-featured-content-dep--alert-link:focus{
    outline:var(--brand-neutral-white) solid 2px;
  }

@media (min-width: 768px){

.se-featured-content-dep--alert-link{
    padding:0 1rem;
    font-size:var(--fs-xl)
}
  }

.se-featured-content-dep--alert-date{
  font-size:var(--fs-sm-mobile);
  color:var(--brand-neutral-white);
  padding-left:0.5rem;
}

@media (min-width: 768px){

.se-featured-content-dep--alert-date{
    padding:0 1rem;
    font-size:var(--fs-sm)
}
  }
`;